<template>
  <iModal :title="modelTitle" v-model="showModal" class-name="vertical-center-modal" width="600px"
    :mask-closable="false" @on-cancel="cancel">
    <div class="admin-add">
      <div class="admin-add-content">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100"
          @submit.native.prevent>
          <FormItem label="展区：" prop="PdGroupName">
            <Select v-model="formInline.PdGroupName" placeholder="请选择展区" @on-change="changeArea">
              <Option v-for="item in area1" :value="item.name" :key="item.name">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="展品类别：" prop="PdKindName" v-show="formInline.PdGroupName">
            <Select v-model="formInline.PdKindName" placeholder="请选择展品类别" multiple :default-label="defaultLabel">
              <Option v-for="item in select" :value="item.name" :key="item.name">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="联络人：" prop="Name">
            <Input v-model="formInline.Name" placeholder="请输入联络人" />
          </FormItem>
          <FormItem label="联络方式：" prop="Mob">
            <Input v-model="formInline.Mob" placeholder="请输入联络方式" />
          </FormItem>
          <FormItem label="座机：" prop="Tel">
            <Input v-model="formInline.Tel" placeholder="请输入座机" />
          </FormItem>
          <FormItem label="邮箱：" prop="Email">
            <Input v-model="formInline.Email" placeholder="请输入邮箱" />
          </FormItem>
        </Form>
      </div>
    </div>
    <div slot="footer">
      <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
      <Button @click="cancel">取消</Button>
    </div>
  </iModal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "email-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
    },
    modelTitle: {
      type: String,
    }
  },
  data () {

    const validEmail = (rule, value, callback) => {
      if (value) {
        if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
          callback();
        } else {
          callback("请输入正确的邮箱地址");
        }
      } else {
        callback();
      }
    };
    return {
      loading: false,
      showModal: false,
      areaIndex: -1,
      area1: [],
      time: [],
      editId: '',
      defaultLabel: [],
      select: [],
      formInline2: {
        PdGroupName: '',
        PdKindName: [],
        Name: "李扬",
        Mob: "13122959676",
        Tel: "98987987987",
        Email: "2624006658@qq.com",
      },
      formInline: {
        PdGroupName: "",
        PdKindName: [],
        Name: "",
        Mob: "",
        Tel: "",
        Email: "",
      },
      ruleInline: {
        PdGroupName: [{ required: true, message: "请选择展区", trigger: "blur" }],
        PdKindName: [{ required: true, type: 'array', message: "请选择展品类别", trigger: "change" }],
        Name: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        Mob: [{ required: true, message: "请输入联络方式", trigger: "blur" }],
        Tel: [{ required: true, message: "请输入座机", trigger: "blur" }],
        Email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          {
            validator: validEmail, trigger: "blur"
          }
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: 'hostSetModule/getHostExhibition',
    }),
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      console.log('$parent', this.$parent);
      if (this.$parent && this.$parent.area1) {
        this.area1 = this.$parent.area1;
        console.log('this.area1', this.area1);
      }
      if (!val) this.$emit("close");
    },
    options (val) {
      if (val.msg) { // 编辑
        this.formInline.name = val.msg.name;
        this.formInline.PdGroupName = val.msg.pdGroupName;
        this.formInline.PdKindName = val.msg.pdKindName.split(';');
        this.formInline.Name = val.msg.name;
        this.formInline.Mob = val.msg.mob;
        this.formInline.Tel = val.msg.tel;
        this.formInline.Email = val.msg.email;
        this.editId = val.msg.id;
        if (val.msg.pdGroupName) { 
          
          this.changeArea(val.msg.pdGroupName);
          this.defaultLabel = this.formInline.PdKindName; 
        }
      }
    },
  }, 
  methods: {
    ...mapActions({ 
      addEmail: 'hostEmailModule/addEmail',
      editEmailInfo: 'hostEmailModule/editEmailInfo',
    }),
    changeArea (e) {
      let obj = this.area1.find(x => x.name === e);
      if (obj && obj.childrens) {
        this.select = obj.childrens;
      }
    }, 
    async handleSubmit (name) {
      let valid = await this.validForm(name);
      if (!valid) return;
      this.loading = true;
      if (this.options.model) { // 编辑模式
        let req = {
          Id: this.editId,
          SetValues: {
            ...this.formInline,
            PdKindName: this.formInline.PdKindName.join(';')
          }
        };
        let bool = await this.editEmailInfo(req).catch(err => {
          this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      } else { // 新增模式
        let req = {
          ExhibitionId: this.exhibitionInfo.id,
          ...this.formInline,
          PdKindName: this.formInline.PdKindName.join(';')
        };
        let bool = await this.addEmail(req).catch(err => {
          this.loading = false;
        });
        if (!bool) {
          this.loading = false;
          this.$Message.error("操作失败，请重新尝试");
        } else {
          this.$emit("finish");
          this.$Message.success("操作成功！");
          this.cancel();
          this.loading = false;
        }
      }
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.editId = '';
    }
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}

.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }

  &-content {
    .submit {
      display: flex;
      justify-content: center;

      button {
        margin-left: -75px;
      }
    }

    img {
      width: 150px;
      height: 150px;
    }
  }

  .form-code-item {
    position: relative;

    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;

      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

